import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

import { Log } from 'ng2-logger';
import * as _ from 'lodash';

@Component({
    selector: 'app-tool-scan',
    templateUrl: './tool-scan.component.html',
    styleUrls: ['./tool-scan.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: ToolScanComponent,
            multi: true
        }
    ]
})
export class ToolScanComponent  implements ControlValueAccessor {

    _logger = Log.create(ToolScanComponent.name);

    @Input() label;
    @Input() labelAlign = 'top';
    @Input() placeholder;
    @Input() formControl: any;
    @Input() showErrors = false;
    @Input() isScanListenerActive = true;

    @Output() scanEvent = new EventEmitter<any>();
    onScan = _.debounce(this.scan, 300);

    get hasError() {
        return this.formControl && this.formControl.errors && this.showErrors;
    }

    private onChangeCallback: (_: any) => {};
    private onTouchedCallback: (_: any) => {};

    @HostBinding('class.label-left') get leftAlignLabel() {
        return this.labelAlign === 'left';
    }

    private scanInput = '';

    get value() {
        return this.scanInput;
    }

    set value(value) {
        this.scanInput = value.split("_").pop();

        this.onChangeCallback(this.scanInput);
        this.scanEvent.emit(this.scanInput);
    }

    writeValue(value) {
        this.scanInput = value;
    }

    scan(toolUID: string) {
        this._logger.info('onScan:: toolUID: ' + toolUID);
        toolUID = toolUID.split("_").pop();
        this.scanInput = toolUID;
        this.scanEvent.emit(toolUID);
    }

    onClear() {
        this.scanInput = '';

        this.onChangeCallback('');
        this.scanEvent.emit('');
    }

    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
}
